module.exports = __webpack_public_path__ + "img/invoice.df9e1046.png";